import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import ComplaintBookViewModel from "./ComplaintBookViewModel";


export const ComplaintBookViewDetail = () => {
    const { id } = useParams();

    const title = "Detalle de raclamo"

    const {
        getComplaintBookById,
        complaintBookData,
        } = ComplaintBookViewModel();
    
    useEffect(() => {
        getComplaintBookById(Number(id));
    }, []);
        
    return(
        <div className='container-fluid'>
            <div className="block-header">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 text-start">
                        <h2>Detalle de reclamo</h2>
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a href="/home" className="text-danger"><FontAwesomeIcon icon={icon({name: 'home'})} /></a>
                            </li>
                            <li className="breadcrumb-item">
                                <a href="/libro-reclamaciones" className="text-danger">Detalle de revlamo</a>
                            </li>
                            <li className="breadcrumb-item">{title}</li>
                        </ul>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="d-flex flex-row-reverse">
                            
                            <div className="p-2 d-flex">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className='title-report'>
                    Aquí puedes ver el detalle de una reclamo.
                </div>
            </div>
            <div className="card p-5">
                <div className="row">
                    {/* <section className="col-lg-12 mb-5 d-flex justify-content-between">
                       
                        <div></div>
                        <section className="d-flex gap-20">
                            <article className="d-flex flex-column">
                                ccc
                            </article>
                            <article className="d-flex flex-column">
                                <FontAwesomeIcon className="fs-1" icon={icon({name: 'ticket'})} />
                                <span>Descargar ticket</span>
                            </article>
                        </section>
                    </section> */}
                    <h4 className="text-start text-center pb-3">DATOS PERSONALES</h4>
                    <section className="col-lg-12 text-start">
                        <h4 className="cod-order"><FontAwesomeIcon className="fs-1" icon={icon({name: 'user'})} /> {complaintBookData?.name} {complaintBookData?.paternalLastName} {complaintBookData?.maternalLastName}</h4>
                        <ul>
                            <li><b>Email: </b>{ complaintBookData?.email}</li>
                            <li><b>WhatsApp: </b><Link target="_blank" title="Contactar por WhatsApp" to={`https://api.whatsapp.com/send?phone=51${complaintBookData?.phoneNumber}`}>{ complaintBookData?.phoneNumber}</Link></li>
                            <li><b>DNI: </b>{ complaintBookData?.documentNumber}</li>
                        </ul>
                    </section>
                    {/* <section className="col-lg-6 d-flex justify-content-end">
                        <div className="d-flex justify-content-between fs-5">
                            <div className="text-end pe-4" >
                                <p className="m-0"><b>Tipo de reclamo:</b> </p>
                                <p><b>Asunto:</b> </p>
                            </div>
                            <div className="text-end">
                                <p className="m-0 cod-order" style={{}}>{ complaintBookData?.claimType }</p>
                                <p>{complaintBookData?.subjectType } </p>
                            </div>
                        </div> 
                    </section> */}
                    <section className="col-lg-12 row">
                        <div className="col-lg-6">
                            <div className="card p-3">
                                <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({name: 'file'})} /> Tipo de documento</p>
                                <p className="m-0">{complaintBookData?.documentType} </p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="card p-3">
                                <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({name: 'phone'})} /> Tipo de número de teléfono</p>
                                <p className="m-0">{complaintBookData?.phoneNumberType}</p>
                            </div>
                        </div>
                        <div className="col-lg-6 mt-3">
                            <div className="card p-3">
                                <p className="fw-bold m-0"><FontAwesomeIcon className="icon-entregado" icon={icon({name: 'shirt'})} /> Tipo de articulo</p>
                                <p className="m-0">{complaintBookData?.purchaseItemType}</p>
                            </div>
                        </div>
                        <div className="col-lg-6 mt-3">
                            <div className="card p-3">
                                <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({name: 'tv'})}  /> Dirección</p>
                                <p className="m-0">{complaintBookData?.address }</p>
                            </div>
                        </div>
                        {
                            complaintBookData?.isMinor &&
                            <>
                                <div className="col-lg-6 mt-3">
                                    <div className="card p-3">
                                        <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({name: 'tv'})}  /> Nombre de tu apoderado</p>
                                        <p className="m-0">{complaintBookData.extension?.representativeName }</p>
                                    </div>
                                </div>
                                <div className="col-lg-6 mt-3">
                                    <div className="card p-3">
                                        <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({name: 'tv'})}  /> Tipo de documento</p>
                                        <p className="m-0">{complaintBookData.extension?.documentType }</p>
                                    </div>
                                </div>
                                <div className="col-lg-6 mt-3">
                                    <div className="card p-3">
                                        <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({name: 'tv'})}  /> Numero de documento</p>
                                        <p className="m-0">{complaintBookData.extension?.documentNumber }</p>
                                    </div>
                                </div>
                                <div className="col-lg-6 mt-3">
                                    <div className="card p-3">
                                        <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({name: 'tv'})}  /> Direccion Apoderado</p>
                                        <p className="m-0">{complaintBookData.extension?.representativeAddress }</p>
                                    </div>
                                </div>
                                <div className="col-lg-6 mt-3">
                                    <div className="card p-3">
                                        <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({name: 'tv'})}  /> Teléfono / Celular del apoderado</p>
                                        <p className="m-0">{complaintBookData.extension?.representativePhoneNumber }</p>
                                    </div>
                                </div>
                                <div className="col-lg-6 mt-3">
                                    <div className="card p-3">
                                        <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({name: 'tv'})}  /> Email Apoderado</p>
                                        <p className="m-0">{complaintBookData.extension?.representativeEmail }</p>
                                    </div>
                                </div>
                            </>
                        }
                        
                    </section>
                    {/* <section className="col-lg-12 row mt-3 border-solid-content mb-4">
                        <div className="col-lg-4">
                            <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({name: 'location-arrow'})} /> Departamento</p>
                            <p className="m-0">{complaintBookData?.department}</p>
                        </div>
                        <div className="col-lg-4">
                            <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({name: 'location-arrow'})} /> Provincia</p>
                            <p className="m-0">{complaintBookData?.province}</p>
                        </div>
                        <div className="col-lg-4">
                            <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({name: 'location-arrow'})} /> Distrito</p>
                            <p className="m-0">{complaintBookData?.district}</p>
                        </div>
                    </section> */}
                    <hr className="mt-5 mb-5"></hr>
                    <h4 className="text-start text-center pb-3">DETALLE DE LA QUEJA O RECLAMO</h4>
                     <section className="col-lg-12 row">
                         
                        <div className="col-lg-6 mt-3">
                            <div className="card p-3">
                                <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({name: 'file'})} /> Identificación del bien contratado</p>
                                <p className="m-0">{complaintBookData?.purchaseItemType} </p>
                            </div>
                        </div>
                        <div className="col-lg-6 mt-3">
                            <div className="card p-3">
                                <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({name: 'phone'})} /> Medio de atención</p>
                                <p className="m-0">{complaintBookData?.serviceChannelType}</p>
                            </div>
                        </div>
                        <div className="col-lg-6 mt-3">
                            <div className="card p-3">
                                <p className="fw-bold m-0"><FontAwesomeIcon className="icon-entregado" icon={icon({name: 'shirt'})} /> Monto</p>
                                <p className="m-0">{complaintBookData?.amount}</p>
                            </div>
                        </div>
                        <div className="col-lg-6 mt-3">
                            <div className="card p-3">
                                <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({name: 'tv'})}  /> Asunto</p>
                                <p className="m-0">{complaintBookData?.subjectType }</p>
                            </div>
                        </div>
                        <div className="col-lg-6 mt-3">
                            <div className="card p-3">
                                <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({name: 'file'})} /> Tipo de reclamo</p>
                                <p className="m-0">{complaintBookData?.claimType} </p>
                            </div>
                        </div>
                        <div className="col-lg-6 mt-3">
                            <div className="card p-3">
                                <p className="fw-bold m-0"><FontAwesomeIcon className="icon-entregado" icon={icon({name: 'shirt'})} /> Pedido</p>
                                <p className="m-0">{complaintBookData?.request}</p>
                            </div>
                        </div>
                        <div className="col-lg-12 mt-3">
                            <div className="card p-3">
                                <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({name: 'file'})} /> Detalle</p>
                                <p className="m-0">{complaintBookData?.detail}</p>
                            </div>
                        </div>
                    </section>
                    <hr className="mt-5 mb-5"></hr>
                    <h4 className="text-start text-center pb-3">ACCIONES ADOPTADAS POR EL PROVEEDOR</h4>
                    <section className="col-lg-12 row">
                        <div className="col-lg-12">
                            <div className="card p-3">
                                <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({name: 'file'})}  /> Detalle</p>
                                <p className="m-0">{complaintBookData?.supplierDetails }</p>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}